import { combineReducers } from 'redux';
import storageSession from 'redux-persist/lib/storage/session';
import persistReducer from 'redux-persist/es/persistReducer';

import filters from './filters';
import saved from './saved';
import data from './data';
import copyData from './copyData';
import user from './user';
import config from './config';
import client from './client';

const filtersPersistConfig = {
  key: 'filters',
  storage: storageSession,
  whitelist: ['market']
};

export default combineReducers({
  filters: persistReducer(filtersPersistConfig, filters),
  data,
  saved,
  copyData,
  user,
  config,
  client
});
